import { render } from "./MainFlashSale.vue?vue&type=template&id=502dc78e&scoped=true"
import script from "./MainFlashSale.vue?vue&type=script&lang=js"
export * from "./MainFlashSale.vue?vue&type=script&lang=js"

import "./MainFlashSale.vue?vue&type=style&index=0&id=502dc78e&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502dc78e"]])

export default __exports__